


/* Shared password requirements checklist. Mirrors @Internal/Models/Password rules
   (9-30 chars, 1 lowercase, 1 uppercase, 1 digit). Each rule shows red while unmet
   and turns green once satisfied. Visible on focus (or as soon as something is typed). */
import { Component, Prop, Vue } from "vue-property-decorator";

interface Rule {
    Key: string;
    Met: boolean;
}

@Component
export default class PasswordChecklist extends Vue {
    @Prop({ default: "" }) private value!: string;
    @Prop({ default: false }) private visible!: boolean;

    private get shown(): boolean {
        return this.visible || this.value.length > 0;
    }

    private get rules(): Rule[] {
        const v = this.value;

        return [
            { Key: "length", Met: v.length >= 9 && v.length <= 30 },
            { Key: "lower", Met: /[a-z]/.test( v ) },
            { Key: "upper", Met: /[A-Z]/.test( v ) },
            { Key: "digit", Met: /\d/.test( v ) }
        ];
    }
}
